import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function cca(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@cca/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@cca/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@cca/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@cca/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@cca/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@cca/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}